(function ($) {
  $(function () {
    var $siteHeader = $('.site-header.is-sticky');

    if ($siteHeader.length) {
      $(window).on('scroll', function () {
        $siteHeader.toggleClass('navbar-fixed-top', $(this).scrollTop() > 1);
      });
    }

    $(window).on('scroll', function () {
      $('.scroll-to-top').toggleClass('show', $(this).scrollTop() > 150);
    });

    $('.scroll-to-top').on('click', function (event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: 0
      }, 700);
    });

    var menuElement = document.querySelector('#my-menu');
    var menuButton = document.querySelector('.menu-btn-burger');
    var navIcon = document.querySelector('#nav-icon');

    if (menuElement && menuButton && navIcon) {
      var menuWrapper = menuElement.closest('.mobile-menu');
      var menuTop = menuElement.querySelector('.mobile-menu-top');
      var menuItems = menuElement.querySelectorAll('.primary-overlay-menu > li, .mobile-menu-contact');
      var menuItemTargets = Array.prototype.slice.call(menuItems);
      var menuAnimationTargets = menuWrapper ? [menuWrapper].concat(menuItemTargets) : menuItemTargets;

      if (menuTop) {
        menuAnimationTargets.push(menuTop);
      }

      var useGsap = typeof window.gsap !== 'undefined' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isMenuOpen = false;

      var animateMenuOpen = function () {
        if (!menuWrapper) {
          return;
        }

        menuWrapper.classList.add('sliding-open');

        if (!useGsap) {
          return;
        }

        window.gsap.killTweensOf(menuAnimationTargets);
        window.gsap.set(menuWrapper, { autoAlpha: 0, clipPath: 'inset(0 0 100% 0)' });
        window.gsap.set(menuItemTargets, { autoAlpha: 0, y: 14 });

        if (menuTop) {
          window.gsap.set(menuTop, { autoAlpha: 0 });
        }

        var openTimeline = window.gsap.timeline()
          .to(menuWrapper, {
            autoAlpha: 1,
            clipPath: 'inset(0 0 0% 0)',
            duration: 0.34,
            ease: 'power3.inOut'
          });

        if (menuTop) {
          openTimeline.to(menuTop, {
            autoAlpha: 1,
            duration: 0.2,
            ease: 'power2.out'
          }, '-=0.22');
        }

        openTimeline.to(menuItemTargets, {
          autoAlpha: 1,
          y: 0,
          duration: 0.26,
          stagger: 0.025,
          ease: 'power3.out'
        }, '-=0.18');
      };

      var animateMenuClose = function () {
        if (!menuWrapper) {
          return;
        }

        if (!useGsap) {
          menuWrapper.classList.remove('sliding-open');
          document.body.classList.remove('mobile-menu-open');
          return;
        }

        window.gsap.killTweensOf(menuAnimationTargets);

        var closeTimeline = window.gsap.timeline({
          onComplete: function () {
            menuWrapper.classList.remove('sliding-open');
            document.body.classList.remove('mobile-menu-open');
            window.gsap.set(menuAnimationTargets, { clearProps: 'opacity,visibility,transform,clipPath' });
          }
        })
          .to(menuItemTargets, {
            autoAlpha: 0,
            y: 8,
            duration: 0.18,
            stagger: {
              each: 0.02,
              from: 'end'
            },
            ease: 'power2.in'
          });

        if (menuTop) {
          closeTimeline.to(menuTop, {
            autoAlpha: 0,
            duration: 0.18,
            ease: 'power2.in'
          }, '-=0.12');
        }

        closeTimeline.to(menuWrapper, {
          autoAlpha: 0,
          clipPath: 'inset(0 0 100% 0)',
          duration: 0.36,
          ease: 'power3.inOut'
        }, '-=0.12');
      };

      var openMenu = function (event) {
        if (event && event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        if (event) {
          event.preventDefault();
        }

        if (isMenuOpen) {
          return;
        }

        isMenuOpen = true;
        menuButton.setAttribute('aria-expanded', 'true');
        navIcon.classList.add('open-custom-menu');
        document.body.classList.add('mobile-menu-open');
        animateMenuOpen();
      };

      var closeMenu = function (event) {
        if (event) {
          event.preventDefault();
        }

        if (!isMenuOpen) {
          return;
        }

        isMenuOpen = false;
        menuButton.setAttribute('aria-expanded', 'false');
        navIcon.classList.remove('open-custom-menu');
        animateMenuClose();
      };

      menuButton.addEventListener('click', openMenu);
      menuButton.addEventListener('keydown', openMenu);

      $('.mob-menu-close').on('click', closeMenu);
      $('#my-menu a').on('click', function () {
        closeMenu();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeMenu();
        }
      });
    }
  });
})(jQuery);
